import type { SVGProps } from 'react';

export const GPayLogo = (props: SVGProps<SVGSVGElement>) => (
    <svg width="60" height="40" viewBox="0 0 60 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M6 0.5H54C57.0376 0.500001 59.5 2.96243 59.5 6V34C59.5 37.0376 57.0376 39.5 54 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
            fill="white"
        />
        <path
            d="M6 0.5H54C57.0376 0.500001 59.5 2.96243 59.5 6V34C59.5 37.0376 57.0376 39.5 54 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6C0.5 2.96243 2.96243 0.5 6 0.5Z"
            stroke="#CCCCCC"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.7007 25.2082V19.7884L31.6292 19.7873C32.8365 19.788 33.8512 19.4082 34.6732 18.6478C35.504 17.9262 35.9684 16.8886 35.9448 15.8071C35.9613 14.7316 35.4976 13.7017 34.6732 12.9824C33.8584 12.2178 32.7626 11.8007 31.6292 11.8237H26.9282V25.2082H28.7007ZM28.7007 18.1437V13.4715L31.6732 13.4704C32.3357 13.4523 32.9744 13.711 33.427 14.1806C33.8824 14.6101 34.1393 15.2 34.1393 15.8161C34.1393 16.4323 33.8824 17.0222 33.427 17.4517C32.9688 17.9115 32.3321 18.1627 31.6732 18.1437H28.7007Z"
            fill="#5F6368"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M43.1315 16.7703C42.3734 16.0911 41.3392 15.7515 40.0291 15.7515C38.3462 15.7515 37.0754 16.3496 36.2166 17.5457L37.7777 18.4993C38.3546 17.6891 39.1381 17.284 40.1282 17.284C40.7595 17.2768 41.3703 17.5007 41.8391 17.9109C42.3064 18.2857 42.5752 18.8445 42.5712 19.4327V19.8257C41.8901 19.4519 41.0233 19.265 39.9708 19.265C38.7378 19.2665 37.7521 19.547 37.0137 20.1066C36.2753 20.6662 35.9062 21.4198 35.9062 22.3674C35.8901 23.2303 36.2759 24.0542 36.9565 24.6101C37.6566 25.2082 38.5267 25.5072 39.5667 25.5072C40.7851 25.5072 41.7613 24.9839 42.4952 23.9373H42.5723V25.2082H44.2677V19.5641C44.2684 18.3808 43.8897 17.4495 43.1315 16.7703ZM38.3239 23.5261C37.9526 23.2665 37.7336 22.8488 37.736 22.4048C37.736 21.9061 37.9771 21.4906 38.4626 21.1489C38.9433 20.8121 39.5437 20.6437 40.2637 20.6437C41.2523 20.6437 42.023 20.8573 42.5757 21.2845C42.5757 22.0064 42.2821 22.6355 41.6949 23.1716C41.1661 23.6847 40.4491 23.9735 39.7011 23.9747C39.2025 23.9837 38.7159 23.8253 38.3239 23.5261Z"
            fill="#5F6368"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M54 16.0506L48.0814 29.2451H46.2517L48.448 24.6283L44.5563 16.0506H46.4829L49.2958 22.6292H49.3343L52.0701 16.0506H54Z"
            fill="#5F6368"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.5381 18.6201C21.5387 18.0961 21.4931 17.5731 21.4016 17.0566H13.9263V20.0181H18.2078C18.0307 20.9738 17.4588 21.8179 16.6246 22.3547V24.277H19.1799C20.676 22.9389 21.5381 20.96 21.5381 18.6201Z"
            fill="#4285F4"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.926 26.1341C16.0651 26.1341 17.8662 25.4527 19.1796 24.278L16.6244 22.3557C15.9132 22.8235 14.9972 23.0904 13.926 23.0904C11.8585 23.0904 10.1036 21.7384 9.47607 19.9165H6.84375V21.8975C8.18925 24.4947 10.9295 26.134 13.926 26.1341Z"
            fill="#34A853"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.47637 19.9165C9.14461 18.9618 9.14461 17.9279 9.47637 16.9732V14.9922H6.84405C5.71865 17.1645 5.71865 19.7252 6.84405 21.8975L9.47637 19.9165Z"
            fill="#FBBC04"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.926 13.7993C15.0564 13.7814 16.1487 14.1957 16.9668 14.9527V14.9527L19.2292 12.758C17.7946 11.4509 15.894 10.7333 13.926 10.7556C10.9295 10.7558 8.18925 12.395 6.84375 14.9922L9.47607 16.9732C10.1036 15.1513 11.8585 13.7993 13.926 13.7993Z"
            fill="#EA4335"
        />
    </svg>
);
